import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, Icon, Select, DatePicker } from 'antd';
import {
  NameSearch,
  OfficeSearch,
  CitySearch,
  StateSearch,
  RegionSearch
} from '@containers/filters';
const { Option } = Select;
const { RangePicker } = DatePicker;

import './FilterList.less';

export default function FilterList(props) {
  const { columns, onChange, onClear, onReload, onCreate, value } = props;

  const renderFilterComponent = (
    key,
    componentName,
    fieldValue,
    innerProps
  ) => {
    switch (componentName) {
      case 'NameSearch':
        return (
          <NameSearch
            value={fieldValue}
            onChange={val => onChange(key, val)}
            {...innerProps}
          />
        );
      case 'OfficeSearch':
        return (
          <OfficeSearch
            value={fieldValue}
            onChange={val => onChange(key, val)}
          />
        );
      case 'RegionSearch':
        return (
          <RegionSearch
            value={fieldValue}
            onChange={val => onChange(key, val)}
          />
        );
      case 'CitySearch':
        return (
          <CitySearch value={fieldValue} onChange={val => onChange(key, val)} />
        );
      case 'StateSearch':
        return (
          <StateSearch
            value={fieldValue}
            onChange={val => onChange(key, val)}
          />
        );
      case 'BooleanSelect':
        return (
          <Select
            autoClearSearchValue={true}
            mode="tags"
            size="default"
            onChange={val => onChange(key, val)}
            value={fieldValue}
            {...innerProps}
          >
            <Option key="active">Active</Option>
            <Option key="inactive">Inactive</Option>
          </Select>
        );
      case 'SimpleSelect': {
        const { options, label, ...restInnerProps } = innerProps;
        return (
          <Select
            autoClearSearchValue={true}
            mode="tags"
            size="default"
            value={fieldValue}
            placeholder={label}
            onChange={val => onChange(key, val)}
            {...restInnerProps}
          >
            {options.map(d =>
              d.value ? (
                <Option key={d.value}>{d.label}</Option>
              ) : (
                <Option key={d}>{d}</Option>
              )
            )}
          </Select>
        );
      }
      case 'DateSelect': {
        return (
          <RangePicker
            format="MM/DD/YYYY"
            value={fieldValue}
            onChange={val => onChange(key, val)}
          />
        );
      }
    }

    return null;
  };

  return (
    <React.Fragment>
      <Row type="flex" gutter={16} className="filter-list">
        {columns.map(({ key, component, width, ...rest }) => {
          const { [key]: fieldValue } = value || {};

          return (
            <Col style={{ marginBottom: 8 }} span={width || 6} key={key}>
              {renderFilterComponent(key, component, fieldValue, rest)}
            </Col>
          );
        })}
      </Row>
      <Row type="flex" gutter={16} className="filter-list">
        <Col span={6}>
          <Row type="flex" className="action-btns">
            <Button onClick={onClear} type="danger">
              <Icon type="close-circle" />
              Clear Filters
            </Button>
            <Button onClick={onReload} type="dashed">
              <Icon type="reload" />
              Refresh
            </Button>
            {onCreate && (
              <Button onClick={onCreate} type="primary">
                <Icon type="plus" />
                Create New
              </Button>
            )}
          </Row>
        </Col>
      </Row>
    </React.Fragment>
  );
}
FilterList.propTypes = {
  columns: PropTypes.array.isRequired,
  value: PropTypes.object,
  onChange: PropTypes.func,
  onClear: PropTypes.func,
  onReload: PropTypes.func,
  onCreate: PropTypes.func
};

FilterList.defaultProps = {
  value: {}
};
